import PropTypes from 'prop-types';

import '../PercentTable.scss';

const PercentTableItem = ({ name, color, count, onHover, onMouseClick, onMouseLeave, focused }) => {
    return <li  style={{ '--color': color }}
        onMouseOver={onHover.bind(null, name)}
        onMouseLeave={onMouseLeave}
        onClick={onMouseClick.bind(null, name)}
        className={focused === name ? 'focused' : ''}
    >
        <span>{name}</span>
        <span>{count}</span>
    </li>;
};

PercentTableItem.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    count: PropTypes.string,
    onHover: PropTypes.func,
    onMouseClick: PropTypes.func,
    onMouseLeave: PropTypes.func,
    focused: PropTypes.string
};

export default PercentTableItem;
